<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Import Media from File</h1>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <!-- Download Template Section -->
                <div class="has-text-centered has-margin-bottom-20">
                  <p class="has-text-grey has-margin-bottom-10">
                    Need the import template? Download it here:
                  </p>
                  <b-button
                    icon-left="download"
                    type="is-info"
                    outlined
                    @click="downloadTemplate"
                    :loading="downloadingTemplate"
                  >
                    Download Template (v2.1)
                  </b-button>
                </div>
                <hr />
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(importUrl)">
                    <div class="columns is-multiline is-centered">
                      <div class="column is-6">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Import URL"
                            rules="required"
                          >
                            <b-field
                              label=""
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-upload
                                v-model="file"
                                class="file-label"
                                accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
                              >
                                <span class="file-cta">
                                  <b-icon
                                    class="file-icon"
                                    icon="upload"
                                  ></b-icon>
                                  <span class="file-label"
                                    >Click to select file (Excel or CSV)</span
                                  >
                                </span>
                                <span v-if="file" class="file-name">
                                  {{ file.name }}
                                </span>
                              </b-upload>
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <b-button
                          icon-left="arrow-left"
                          class="is-medium has-margin-right-10"
                          tag="router-link"
                          :to="{ name: 'ManageMedia' }"
                        >
                          Back to List</b-button
                        >
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Import
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import MediaApi from '@/api/media'

export default {
  name: 'ImportMedia',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Import Media'
  },
  data() {
    return {
      loading: false,
      downloadingTemplate: false,
      file: null
    }
  },
  methods: {
    async downloadTemplate() {
      this.downloadingTemplate = true
      try {
        await MediaApi.downloadImportTemplate()
        this.$buefy.toast.open({
          message: 'Template downloaded successfully',
          position: 'is-top',
          type: 'is-success'
        })
      } catch (err) {
        console.error('Error downloading template:', err)
        this.$buefy.toast.open({
          message: 'Error downloading template',
          position: 'is-top',
          type: 'is-danger'
        })
      } finally {
        this.downloadingTemplate = false
      }
    },
    importUrl() {
      this.loading = true
      MediaApi.importMediaFile(this.file)
        .then(response => {
          // Build message showing new vs updated episodes
          let message = `Import complete: ${response.titles} new titles, ${response.episodes} new episodes`
          if (response.updatedEpisodes > 0) {
            message += `, ${response.updatedEpisodes} episodes updated`
          }
          if (response.segments > 0) {
            message += `, ${response.segments} segments`
          }
          this.$buefy.toast.open({
            message: message,
            position: 'is-top',
            type: 'is-success',
            duration: 5000
          })

          // Show warning toast if there were duplicate title matches
          if (response.warnings && response.warnings.length > 0) {
            this.$buefy.toast.open({
              message: `Warning: ${response.warnings.length} title(s) had duplicate matches. Check console for details.`,
              position: 'is-top',
              type: 'is-warning',
              duration: 8000
            })
            console.warn('Import duplicate warnings:', response.warnings)
          }

          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error importing media',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
